import { MatChipInputEvent } from '@angular/material/chips';

// import { FuseUtils } from '@fuse/utils';

export class AttributeType
{
    id: number;
    name: string;
    basicType: string;
    candidateValues: string[];
    defaultValue: string;
    multiLine: boolean;
    multiValue: boolean;
    required = false;
    percentage: boolean;

    constructor(entity?)
    {
        entity = entity || {};
        this.id = entity.id;
        this.name = entity.name;
        this.basicType = entity.basicType;
        this.candidateValues = entity.candidateValues;
        this.defaultValue = entity.defaultValue;
        this.multiLine = entity.multiLine;
        this.multiValue = entity.multiValue;
        this.required = false;
        this.percentage = entity.percentage;
    }

    // public get options(){
    //    if (!this._options)
    //     this._options = this.candidateValues ? this.candidateValues.split(',') : [];
    //    return this._options;
    // }

    // public set options(aux:string[]){

    // }
}

export class AttributeValue
{
    
    id: number;
    attributeType: AttributeType;
    name: string;
    value: string;
    
    
    /**
     * Constructor
     *
     * @param product
     */
    constructor(attribute?)
    {
        this.id = attribute.id || null;
        this.attributeType = attribute.attributeType;
        this.name = attribute.name || '';
        if (attribute.value != null && this.attributeType != null && this.attributeType.basicType === 'DateType'){
            const splitted: string[] = attribute.value.split('/');
            this.value = splitted.length === 3 ? splitted[2] + '-' + splitted[1] + '-' + splitted[0] : this.value;
        }else {
            this.value = attribute.value || '';
        }
        
    }

    // valueToDate(){
    //     if (this.value!=null){
    //         let splitted:String[]=this.value.split("//")
    //         this.value = splitted.length==3 ? splitted[2]+'-'+splitted[1]+'-'+splitted[0] : this.value;

    //     }
    //     return this.value==null ? null : new Date(this.value);
    // }

    

    
}
